export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7136.35196a46.jpg";